import script from "./OfferItemSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferItemSingle.vue?vue&type=script&setup=true&lang=js"

import "./OfferItemSingle.vue?vue&type=style&index=0&id=4d9b35e0&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d9b35e0"]])

export default __exports__